import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./YuJaTextBox.module.css";
import { YuJaTooltip } from "./YuJaTooltip";
import {generateUUID} from "../../utils/helpers";
import {ReactComponent as ERROR} from "../../images/cross_cricle_red.svg"



export const YuJaTextBox = ({
                                disabled=false,
                                isInvalid=false,
                                value="",
                                getActualValue,
                                name="",
                                errorMsg="",
                                onBlur,
                                onChange,
                                onKeyDown,
                                placeholder,
                                type="text",
                                inputAlign="left",
                                before,
                                after,
                                containerStyle={},
                                style={},
                                inputClass =null, 
                                label="textbox",
                                useValue=false,
                                showRemaining=false,
                                tooltip = "",
                                showTooltip=false,
                                isMultiple=false,
                                limitedSpace=true,
                                ...props
}) => {
    const { t } = useTranslation();
    const [randomId, ] = useState(() => generateUUID());
    const [inputPadding, setInputPadding] = useState(10);
    const [inputVal, setInputVal] = useState(() => {
        if (!!getActualValue) {
            return getActualValue(value);
        } else {
            return value;
        }
    });


    const onChangeFunc = (e) => {
        setInputVal(e.target.value);
        if (onChange) {
            onChange(e, setInputVal);
        }
    }

    const onKeyDownFunc = (e) => {
        if (onKeyDown) {
            onKeyDown(e);
        }
    }

    const onBlurFunc = (e) => {
        if (onBlur) {
            onBlur(e);
        }
    }

    const onClick = (e) => {
        let actualInput = document.querySelector(`[data-yuja-textbox-id='${randomId}']`);
        if (e.target !== actualInput) {
            actualInput.focus();
        }
    }

    useEffect(() => {
        if (!!getActualValue) {
            setInputVal(getActualValue(value));
        } else {
            setInputVal(value);
        }
    }, [value])


    useEffect(() => {
        if (containerStyle.padding) {
            setInputPadding(containerStyle.padding);
            return;
        }

        let actualInput = document.querySelector(`[data-yuja-textbox-id='${randomId}']`);

        if (!actualInput) {
            return;
        }

        const inputFontSize = parseFloat(getComputedStyle(actualInput).fontSize);
        if (inputFontSize <= 13) {
            setInputPadding(9);
        }

        if (inputFontSize > 16) {
            setInputPadding(inputFontSize * 10 / 16);
        }
    }, []);

    return (
        <span
            className={`${styles.box} ${disabled ? styles.disabled : ""} ${isInvalid && limitedSpace ? styles.invalid : ""}`}
            style={{
                ...containerStyle,
                padding: inputPadding,
                marginBottom: isInvalid && errorMsg && !limitedSpace ? 26 : containerStyle.marginBottom
            }}
            onClick={onClick}
        >
            {before}
            {showTooltip && (!!placeholder || !!tooltip)
                ?
                <YuJaTooltip offset={20} text={!!tooltip ? tooltip : placeholder} placement={"bottom"}>
                    <InputBox
                        isMultiple={isMultiple}
                        data-yuja-textbox-id={randomId}
                        className={inputClass ? inputClass : ""}
                        name={name}
                        value={useValue ? (!!getActualValue ? getActualValue(value) : value) : inputVal}
                        type={type}
                        onChange={onChangeFunc}
                        onKeyUp={onKeyDownFunc}
                        onBlur={onBlurFunc}
                        disabled={disabled}
                        placeholder={placeholder}
                        style={{...style, textAlign: inputAlign}}
                        aria-label={label === "textbox" ? placeholder + t("accessibility.textboxSuffix") : label}
                        {...props}
                    />
                </YuJaTooltip>
                :
                <InputBox
                    isMultiple={isMultiple}
                    data-yuja-textbox-id={randomId}
                    className={inputClass ? inputClass : ""}
                    name={name}
                    value={useValue ? (!!getActualValue ? getActualValue(value) : value) : inputVal}
                    type={type}
                    onChange={onChangeFunc}
                    onKeyUp={onKeyDownFunc}
                    onBlur={onBlurFunc}
                    disabled={disabled}
                    placeholder={placeholder}
                    style={{...style, textAlign: inputAlign}}
                    aria-label={label === "textbox" ? placeholder + t("accessibility.textboxSuffix") : label}
                    {...props}
                />
            }

            {showRemaining && props.maxLength &&
                <div className={styles.charCount}>
                    {props.maxLength - (useValue ? (!!getActualValue ? getActualValue(value)?.length : value?.length) : inputVal?.length)}
                </div>
            }
            {after}

            {isInvalid && errorMsg && limitedSpace &&
                <div className={styles.iconContainer}>
                    <YuJaTooltip placement={"right"} text={errorMsg}
                                 tooltipStyle={{maxWidth: 300, whiteSpace: "pre-wrap"}}>
                        <div className={styles.invalidIcon}/>
                    </YuJaTooltip>
                </div>
            }

            {isInvalid && errorMsg && !limitedSpace &&
                <div className={styles.normalErrorMsgContainer}>
                    <ERROR style={{flexShrink: 0, width: 18, height: 18}}/> <span>{errorMsg}</span>
                </div>
            }
        </span>
    )
}

const InputBox = React.forwardRef((props, ref) => {
    const {isMultiple, ...rest} = props;

    if (!isMultiple) {
        return <input {...rest} ref={ref}/>
    } else {
        return <textarea {...rest} ref={ref}/>
    }
});


YuJaTextBox.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.oneOf(["text", "password", "number"]),
    disabled: PropTypes.bool,
    isInvalid: PropTypes.bool,
    placeholder: PropTypes.string,
    // onChange: PropTypes.func,
    inputAlign: PropTypes.oneOf(["left", "center", "right"]),
}